import { render } from "./fact.vue?vue&type=template&id=d85d7402&scoped=true"
import script from "./fact.vue?vue&type=script&lang=js"
export * from "./fact.vue?vue&type=script&lang=js"

import "./fact.vue?vue&type=style&index=0&id=d85d7402&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85d7402"]])

export default __exports__